module.exports = __webpack_public_path__ + "static/img/img40.f3f77bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img40.png
// module id = 8X3h
// module chunks = 1